function LandingHero ({ scrollToSection }) {
  return (
    <section className='lp-hero-section'>
      <div className='lp-hero-content'>
        <div className='lp-hero-text'>
          <h1>
            Wissen zentral verwalten.
            <br />
            <span className='lp-highlight'>Probleme schneller lösen.</span>
          </h1>
          <p className='lp-hero-subtitle'>
            Die intelligente Wissensdatenbank für Servicetechniker. Sparen Sie
            Zeit, reduzieren Sie Standzeiten und bewahren Sie wertvolles
            Know-how – auch bei Mitarbeiterwechsel.
          </p>
          <div className='lp-hero-cta'>
            <a
              href='#contact'
              className='lp-btn-primary lp-btn-large'
              onClick={(e) => {
                e.preventDefault()
                scrollToSection('contact')
              }}
            >
              Demo anfragen
            </a>
            <a
              href='#features'
              className='lp-btn-secondary lp-btn-large'
              onClick={(e) => {
                e.preventDefault()
                scrollToSection('features')
              }}
            >
              Mehr erfahren
            </a>
          </div>
          <p className='lp-hero-note'>Keine Kreditkarte erforderlich</p>
        </div>
        <div className='lp-hero-visual'>
          <div className='lp-hero-image-wrapper'>
            <img
              src='/hero-app-forest.webp'
              alt='App in Verwendung im Wald'
              className='lp-hero-image'
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default LandingHero

